import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'
import { VisuallyHidden } from '@radix-ui/react-visually-hidden'

type ContextoValue = 'OBRA' | 'REUNIAO' | 'LIVRE'

interface ContextoOption {
  value: ContextoValue
  icon: string
  label: string
  desc: string
  color: string
}

interface ContextoSelectorModalProps {
  open: boolean
  onSelect: (value: ContextoValue) => void
  onCancel: () => void
}

const CONTEXTOS: ContextoOption[] = [
  { value: 'OBRA',    icon: 'construction', label: 'Obra',    desc: 'Visita de obra ou vistoria',   color: '#C8A84B' },
  { value: 'REUNIAO', icon: 'groups',       label: 'Reunião', desc: 'Reunião presencial ou remota',  color: 'var(--color-hero)' },
  { value: 'LIVRE',   icon: 'edit_note',    label: 'Livre',   desc: 'Nota avulsa, referência rápida', color: '#7A7A7A' },
]

export default function ContextoSelectorModal({ open, onSelect, onCancel }: ContextoSelectorModalProps) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onCancel()}>
      <DialogContent className="max-w-[320px] p-0 gap-0 border-none">
        <VisuallyHidden><DialogTitle>Tipo de registro</DialogTitle></VisuallyHidden>
        <p className="text-[11px] tracking-[0.09em] uppercase text-[#999] font-bold px-5 pt-5 pb-3">
          Tipo de registro
        </p>
        <div className="flex flex-col">
          {CONTEXTOS.map((ctx, i) => (
            <button
              key={ctx.value}
              onClick={() => onSelect(ctx.value)}
              className={`flex flex-col w-full px-5 py-4 text-left cursor-pointer transition-colors duration-100 hover:bg-white/[0.05] ${i < CONTEXTOS.length - 1 ? 'border-b border-white/[0.04]' : ''}`}
            >
              <p className="text-[22px] font-semibold text-[#f0f0f0] leading-tight">{ctx.label}</p>
              <p className="text-[11px] text-muted mt-1">{ctx.desc}</p>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  )
}
